module.exports = __webpack_public_path__ + "static/img/bb2a77d2-08b7-47f7-96bb-5351969436d0.c4c9201.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bb2a77d2-08b7-47f7-96bb-5351969436d0.jpg
// module id = BX5y
// module chunks = 46